import AdvisorSettings from '@/components/settings/AdvisorSettings'

const AdvisorSettingsScreen = () => {
  return <AdvisorSettings />
}

export default AdvisorSettingsScreen
